import * as api from '@/api/give-course/sigin'
import * as TYPES from './type';

export default {
  //授课签到
  async postSKSignAdd({ commit, state }, { paramets, cb}) {
    const result = await api.reqSKSignAdd(paramets)
    commit(TYPES.SK_SIGIN_ADD, { result })
    cb && cb()
  },
  async getSKSignStuList({ commit, state }, { paramets, cb}) {
    const result = await api.reqSKSignStuList(paramets)
    commit(TYPES.SK_SIGIN_STU_LIST, { result })
    cb && cb()
  },
  async getSKSignList({ commit, state }, { paramets, cb}) {
    const result = await api.reqSKSignList(paramets)
    commit(TYPES.SK_SIGIN_LIST, { result })
    cb && cb()
  },
  async getSKSignOn({ commit, state }, { paramets, cb}) {
    const result = await api.reqSKSignOn(paramets)
    commit(TYPES.SK_SIGIN_ON, { result })
    cb && cb()
  },
  async getSKSignDetail({ commit, state }, { paramets, cb}) {
    const result = await api.reqSKSignDetail(paramets)
    commit(TYPES.SK_SIGIN_DETAIL, { result })
    cb && cb()
  },
  async putSKSignEdit({ commit, state }, { paramets, cb}) {
    const result = await api.reqSKSignEdit(paramets)
    commit(TYPES.SK_SIGIN_EDIT, { result })
    cb && cb()
  },
  async postSKSignStuEdit({ commit, state }, { paramets, cb}) {
    const result = await api.reqSKSignStuEdit(paramets)
    commit(TYPES.SK_SIGIN_STU_EDIT, { result })
    cb && cb()
  },
  async postSKSignStuBatchEdit({ commit, state }, { paramets, cb}) {
    const result = await api.reqSKSignStuBatchEdit(paramets)
    commit(TYPES.SK_SIGIN_STU_BATCH_EDIT, { result })
    cb && cb()
  },
}